import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import { inputStyles } from 'assets/components/inputs/Input';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import Currency from 'models/enums/Currency';
import { usePostingAccountProvider } from '../Finance.PostingAccount.Hooks';

export default function FinancePostingAccountEdit() {
  const { lang } = getLocales();
  const { selected, pageRouter, saveApi, productApi } = usePostingAccountProvider();

  return (
    <>
      <ModalForm<Api.Core.PostingAccount.Save.IRequest>
        subcomponents={ThemeModalFormDefault}
        dependencyArray={[selected]}
        title={lang.postingAccount}
        default={selected?.toJSON() || { currency: 'CAD' }}
        onCancel={pageRouter.updateParams}
        onSubmit={(data) => saveApi.execute(data)}
        validation={(data, errors) => {
          if (!data.ledgerAccountName) errors.ledgerAccountName = lang.mustNotBeEmpty;
          if (!data.currency) errors.currency = lang.mustNotBeEmpty;
        }}
        render={({ form }) => (
          <>
            <FormWrapper>
              <TextInput
                name="ledgerAccountName"
                label={lang.postingAccountName}
                value={form.data.ledgerAccountName}
                error={form.errors.ledgerAccountName}
                onChange={form.update}
                icon={<Icon class="if-quill-pen" />}
              />
              <CheckInput
                name="isActive"
                label={lang.isActive}
                value={form.data.isActive}
                onChange={form.update}
                class={inputStyles.check.switch}
                htmlElementProps={{ title: form.data.isActive ? lang.disable : lang.enable }}
              />
              <CheckInput
                name="isPayable"
                label={lang.isPayable}
                value={form.data.isPayable}
                onChange={form.update}
                class={inputStyles.check.switch}
                htmlElementProps={{ title: form.data.isPayable ? lang.disable : lang.enable }}
              />
              <CheckInput
                name="isReceivable"
                label={lang.isReceivable}
                value={form.data.isReceivable}
                onChange={form.update}
                class={inputStyles.check.switch}
                htmlElementProps={{ title: form.data.isReceivable ? lang.disable : lang.enable }}
              />
              <SelectInput
                name="products"
                label={lang.products}
                data={productApi?.payload?.data?.map((item) => item.displayInfo)}
                isMultiselect
                value={form.data.products?.map((it) => it.id)}
                onChange={({ products: idList }) =>
                  form.update({
                    products: idList.map((id: number) => form.data.products?.find((it) => it.id === id) ?? { id }),
                  })
                }
                icon={<Icon class="fas-clipboard-list" />}
              />
              <SelectInput
                name="currency"
                label={lang.currency}
                data={Object.values(Currency).map((it) => ({ id: it, title: it }))}
                value={form.data.currency}
                error={form.errors.currency}
                onChange={form.update}
                icon={<Icon class="fas-dollar-sign" />}
              />
            </FormWrapper>
          </>
        )}
      />
    </>
  );
}
